import React from 'react';
import Navbar from './global-components/navbar-v4';
import AboutV2 from './section-components/about-v2';
import Featuresv1 from './section-components/features-v1';
import Gallery   from './section-components/gallery-v1';
import Apartment from './section-components/apartment-v1';
import VideoV1 from './section-components/video-v1';
import Category from './section-components/category-v1';
import CallToActionV1 from './section-components/call-to-action-v1';
import Footer from './global-components/footer';
import Contact from './contact';
import Banner from './section-components/banner-v3';


const Diamantine = () => {
    return <div>
        <Navbar /> 
        <Banner 
        title={"Projet Ezzahara"}
        subtitle={"vivre ou investir à deux pas de la mer"}
        description={"Un cadre de vie exceptionnel\nSitué à Ezzahara, près de Ksar Sghir, le projet Ezzahara vous offre bien plus qu’un simple logement."}
        btn={"Découvrir plus"} />

        
        <Contact/>
        <CallToActionV1 />
        <Footer />
    </div>
}

export default Diamantine

